<template>
  <div class="pa-6 mb-7 d-flex justify-center" style="width: 100%;min-height: 100%;">
    <div style="width: 100%; max-width: 980px;">
      <h2 class="d-flex justify-center py-2">
        {{ organizationName }}
      </h2>

      <v-divider class="pt-2" />
      <div
        v-if="userIsOrgAdmin"
        class="font-weight-light font-x-small font-italic pb-4"
      >
        <span class="pl-4">
          <v-icon
            color="#B83835"
          >
            person
          </v-icon>
          Admins: {{ numAdmins }}
        </span>
        <span class="pl-4">
          <v-icon>person</v-icon>
          Members: {{ organization.users.length }}
        </span>
        <span class="pl-4">
          <v-icon>group</v-icon>
          Groups: {{ organization.groups.length }}
        </span>
      </div>
      <div v-if="userIsOrgAdmin">
        <UserManagement
          :organization="organization"
          :loading="loading"
          class="pa-4"
          @saved="fetchOrganization()"
        />
        <GroupManagement
          :organization="organization"
          :loading="loading"
          class="pa-4"
          @saved="fetchOrganization()"
        />
      </div>
      <div class="d-flex justify-center mt-1" v-else>
        Sorry, you don't have admin rights!
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { types } from '@/store/rootTypes';
import UserManagement from '../admin/UserManagement';
import GroupManagement from '../admin/GroupManagement';
import { OrganizationService } from '../admin/OrganizationService';

export default {
  name: 'OrgAdmin',
  components: { UserManagement, GroupManagement },
  computed: {
    ...mapGetters({
      organizationId: types.authentication.getters.organizationId,
      organizationName: types.authentication.getters.organizationName,
      userIsOrgAdmin: types.user.getters.userIsOrgAdmin,
    }),
    loading() {
      return this.organization.id === undefined;
    },
    numAdmins() {
      return this.organization.users.filter(user => user.roles.includes('NOOS_ADMIN')).length;
    },
  },
  data: () => ({
    organization: {
      groups: [],
      users: [],
    },
  }),
  async created() {
    this.fetchOrganization();
  },
  methods: {
    async fetchOrganization() {
      this.organization = {
        groups: [],
        users: [],
      };

      const organizationService = new OrganizationService();
      const organization = await organizationService.fetchOrganization(this.organizationId);
      const users = await organizationService.fetchUsersInOrganization(this.organizationId);
      const groups = await organizationService.fetchGroupsInOrganization(this.organizationId);

      users.sort((a, b) => a.firstName.localeCompare(b.firstName));
      groups.sort((a, b) => a.name.localeCompare(b.name));

      this.organization = {
        id: this.organizationId,
        name: this.organizationName,
        users,
        groups,
        maxUsers: organization.maxUsers,
        maxGroups: organization.maxGroups,
      };
    },
  },
};
</script>
